module.exports = __webpack_public_path__ + "84e163d58ff4919d203cb662e4176a14.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/trumpet/16_D#3.mp3
// module id = 115
// module chunks = 0